<template>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button class="button_back" @click="goBack('dateForm')">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Record a Shift</ion-title>
  </ion-toolbar>

  <div class="main_wrapper ion-padding">
    <div class="container">
    <el-form
      :model="formsData.dateForm"
      :rules="formsData.dateForm.rules"
      :ref="(el) => (formsData.dateForm.ref = el)"
      :label-position="'top'"
      @submit.prevent="goNext('dateForm')"
    >
      <page-title title="Hourly Payment range" v-if="isAustralia" subtitle="(Excluding super)" />
      <el-form-item
        class="rate_form_inputs_wrapper"
        prop="rate"
      >
        <el-form-item label="Pay Rate" :required="true">
          <div class="el-input el-input--prefix">
            <input
              type="tel"
              class="input_currency el-input__inner"
              :value="formsData.dateForm.rate.value"
              :placeholder="'0.00'"
              v-imask="formsData.dateForm.rate.mask"
              @accept="onFormMaskAccept($event, 'dateForm', 'rate')"
              @blur="checkFormValidation('dateForm', true, 'rate')"
            />
            <span class="el-input__prefix">$</span>
          </div>
        </el-form-item>
      </el-form-item>
    </el-form>
    <el-button class="primary w-full mt-auto" @click="goNext('dateForm')" :disabled="formsData.dateForm.disabled">
        Next
      </el-button>
    </div>
  </div>
</template>

<script>
"@/components/Vendor/Element";

import {
  onMounted,
  inject,
} from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import {
  IonToolbar,
  IonButton,
  IonButtons,
  IonIcon,
  IonTitle,
} from "@ionic/vue";
import { useStore } from "vuex";
import {
  useRouter,
  // useRoute
} from "vue-router";
import formHooks from "@/hooks/form/form";
import formValidate from "@/hooks/form/validate/validate";
import formMasks from "@/hooks/form/mask/mask";

import IMaskDirective from "@/directives/vue-imask/directive";
import IMask from "imask/esm/imask";
import PageTitle from "@/components/PageTitle/PageTitle.vue";
import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    IonTitle,
    PageTitle
  },
  directives: {
    imask: IMaskDirective,
  },
  setup() {
    const $store = useStore();
    const $router = useRouter();
    const setPageClassGlobal = inject("setPageClassGlobal");
    const jobCreatePageData = $store.getters.getGuestShiftRecordCreatePageData;
    const isAustralia = isAustraliaRegion();

    const payRate = jobCreatePageData.payRate;

    const formsDataArray = {
      dateForm: {
        rate: {
          value:payRate
              ? IMask.createMask(formMasks.rate).resolve("" + payRate)
              : null,

          mask: formMasks.rate,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "payRate",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
      },
    };
    const goBack = (formName) => {
      // let data = getFormValues(formName)
      $store.dispatch("setGuestShiftRecordCreatePageData", getFormValues(formName));
      $router.push({
        name: "create_guest_shift_schedule",
      });
    };
    const goNext = (formName) => {
      formsRefs[formName].value.validate((valid) => {
        if (valid) {
          $store.dispatch("setGuestShiftRecordCreatePageData", getFormValues(formName));
          $router.push({
            name: "guest_shift_additional_information",
          });
        } else {
          setFormValidation(formName, false, false);
          console.log("error submit!!");
          return false;
        }
      });
    };

    onMounted(() => {
      setPageClassGlobal("global_job_create_page");
      setFormRefs();
      formsRefs.dateForm.value.$el[0].focus();
      checkFormValidation("dateForm", false);
    });

    const {
      onFormMaskAccept,
      checkFormValidation,
      setFormValidation,
      getFormValues,
      setFormRefs,
      formsData,
      formsRefs,
    } = formHooks(formsDataArray);



    return {
      formsData,
      onFormMaskAccept,
      checkFormValidation,
      goBack,
      goNext,
      isAustralia
    };
  },
};
</script>
